import { render, staticRenderFns } from "./PresentationPdfUploader.vue?vue&type=template&id=1dac94c1"
import script from "./PresentationPdfUploader.vue?vue&type=script&lang=js"
export * from "./PresentationPdfUploader.vue?vue&type=script&lang=js"
import style0 from "./PresentationPdfUploader.vue?vue&type=style&index=0&id=1dac94c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports